import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import Card from '../../components/Card/Card';
import { getAccountTypeDisplayName } from './utils';
import { formatDate } from '../../flows/shared/dateUtils';

const ExistingApplicationCard = ({ journey }) => {
  const { next } = useContext(FlowContext);
  return (
    <Card
      title={
        <div>
          {journey.applicationType === 'FO_NASU' && ' - Push to Web'}
          {journey.applicationType === 'NASU' &&
            getAccountTypeDisplayName(
              journey.accountType,
              journey.fromAccountType
            )}
          <br />
        </div>
      }
      subtitle={
        <div>Started on {formatDate(journey.createDate, 'MMM D, YYYY')}</div>
      }
      buttonText="Continue"
      buttonFunction={next(journey)}
      buttonID="btnContinue"
    />
  );
};

export default ExistingApplicationCard;
